import { render, staticRenderFns } from "./component-menu.vue?vue&type=template&id=43dd04b4&scoped=true&"
import script from "./component-menu.vue?vue&type=script&lang=js&"
export * from "./component-menu.vue?vue&type=script&lang=js&"
import style0 from "./component-menu.vue?vue&type=style&index=0&id=43dd04b4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43dd04b4",
  null
  
)

export default component.exports